/**
 * @file Overview service util
 * @author XiaoBin Li(lixiaobin8878@gmail.com)
 */


import axios from 'axios'
let querystring = require('querystring')
let showErrTip = true

/**
 * 添加ajax response interceptor
 */
axios.interceptors.response.use(function (res) {
    let data = res.data
    let code = data.code
    if (typeof data === 'string') {
        data = JSON.parse(data)
    }
    if (code === 0 || isNaN(code)) {
        return data
    } else {
        // 未登录状态
        if (code === 1000000500) {
            if (data.data && data.data.redirectUrl) {
                let url = window.location.href
                if (url.indexOf('huatu') > -1) {
                    window.location.href = data.data.redirectUrl + encodeURIComponent(url)
                }
            } else {
                toast(data.msg, 'error')
            }
            return Promise.reject(data)
        } else if (code === 1000000400) {
            toast(data.msg, 'error')
        } else if (code === 2000000800) {
            toast(data.msg, 'error')
        } else if (showErrTip) {
            toast(data.msg || '系统异常', 'error')
        }
        return Promise.reject(data)
    }
}, function (error) {
    let response = error.response
    let data = response.data
    let status = error.response.status
    // 401 表明没有权限，跳转到登录页，与 status 200 code为1000000500 逻辑类似
    if (status === 401) {
        let url = window.location.href
        let oaToken = sessionStorage.getItem('oaToken') || localStorage.getItem('oaToken')
        // console.log("data", data)
        if (!data || !data.data || !data.data.redirectUrl) {
            // toast(data.msg || '系统异常', 'error')
            console.log("url", url)
            if (url && !url.includes('403')) {
                window.location.href = '/403'
            }
        } else {
            if (!localStorage.getItem('token') && !oaToken) {
                window.location.href = data.data.redirectUrl + encodeURIComponent(url)
            }
        }
        // 服务器异常，显示错误页面
    } else if (status === 502) {
        let errorPageUrl = 'https://download.huatu.com/502'
        document.write(`<iframe id="error-500" style="width:100%; height: 100%;" scrolling="no" boder="0" marginheight="0" marginwidth="0" frameborder="0" src="${errorPageUrl}"></iframe>`)
        // 监听iframe来的刷新事件
        window.addEventListener('message', (event) => {
            if (event.data.type === 'refresh') {
                window.location.reload()
            }
        })
        document.close()
        return
    } else if (!response) {
        toast('无网络链接，请检查后重试', 'error')
    } else {
        toast((data && data.msg ? data.msg : '系统异常'), 'error')
    }
    console.log("error", error)
    return Promise.reject(error)
})

/**
 * 发送 post 请求
 *
 * @param {string} url 请求 url
 * @param {Object} data 发送的数据
 * @return {Promise}
 */
export function post(url, data = {}) {
    return axios.post(url, querystring.stringify(data))
}

export async function postWithJson(url, data = {}) {
    return axios.post(url, data)
}

/**
 * post form参数请求
 *
 * @param {string} url 请求 url
 * @param {Object} data 发送的数据
 * @return {Promise}
 */
export function form(url, data = {}) {
    return axios.post(url,
        querystring.stringify(data),
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
    )
}

/**
 * 发送 delete 请求
 *
 * @param {string} url 请求 url
 * @param {Object} data 发送的数据
 * @return {Promise}
 */
export function del(url, data = {}) {
    return axios.delete(url, {
        params: data
    })
}

/**
 * 发送 get 请求
 *
 * @param {string} url 请求 url
 * @param {Object} data 发送的数据
 * @return {Promise}
 */
export function get(url, data = {}) {
    return axios.get(url, {
        params: data
    })
}

/**
 * 发送 update 请求
 *
 * @param {string} url 请求 url
 * @param {Object} data 发送的数据
 * @return {Promise}
 */
export function put(url, data = {}) {
    return axios.put(url, data)
}

export const postWithFormData = (url, data = {}) => {
    return axios.post(url, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        responseType: 'arraybuffer',
    })
}
// 新增一个用于普通上传的方法（返回 JSON）
export const postWithFormDataJSON = (url, data = {}) => {
    return axios.post(url, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}